import React, { createContext, useContext, useState } from 'react';
import { invalidateBookingsCache } from '../utils/cache';

const AuthContext = createContext();

function getInitialAuth() {
  try {
    const savedUser = localStorage.getItem('user');
    const savedToken = localStorage.getItem('token');
    if (savedUser && savedToken) {
      return { user: JSON.parse(savedUser), token: savedToken, isAuthenticated: true };
    }
  } catch { /* ignore corrupt data */ }
  return { user: null, token: null, isAuthenticated: false };
}

export function AuthProvider({ children }) {
  const initial = getInitialAuth();
  const [isAuthenticated, setIsAuthenticated] = useState(initial.isAuthenticated);
  const [user, setUser] = useState(initial.user);
  const [token, setToken] = useState(initial.token);
  const authChecked = true;

  const login = (userData, accessToken) => {
    // Drop any reservations cached for a previous session/user.
    invalidateBookingsCache();
    setUser(userData);
    setToken(accessToken);
    setIsAuthenticated(true);
    localStorage.setItem('user', JSON.stringify(userData));
    localStorage.setItem('token', accessToken);
  };

  const logout = () => {
    invalidateBookingsCache();
    setUser(null);
    setToken(null);
    setIsAuthenticated(false);
    localStorage.removeItem('user');
    localStorage.removeItem('token');
  };

  const updateUser = (userData) => {
    setUser(userData);
    localStorage.setItem('user', JSON.stringify(userData));
  };

  return (
    <AuthContext.Provider value={{ isAuthenticated, user, token, authChecked, login, logout, updateUser }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}

